import i18n from './index.js'
export default {//印尼西亚语
  translateText: {
    shoppingcart: "cart belanja",
    loginorrefisterText: "login/pendaftaran",
    logoutText: "log keluar",
    personcenterText: "pusat pribadi",
    placeholderText: "silahkan pilih",
    loginText: "login",
    registerText: "registery",
    emailText: "email",
    pwdText: "email",
    forgetpwdText: "Lupa password?",
    nameText: "nama",
    surnameText: "nama keluarga",
    mobileText: "Ponsel",
    setPwdText: "atur kata sandi",
    countryText: "Negara",
    company: "perusahaan",
    birthday:"ulang tahun",
    yearText:"Tahun",
    mouthText:"Bulan",
    dayText:"hari",
    confirmpwdText: "konfirmasi sandi",
    agreeText1: "Saya telah membaca dan setuju",
    agreeText2: "penggunaan istilah",
    agreeText3: "Dan",
    agreeText4: "pernyataan privasi",
    agreeText5: ",Dan telah setuju bahwa beberapa informasi pribadi saya akan diproses di luar perbatasan sesuai dengan pernyataan privasi",
    emailplaceholder: 'tolong ketik email anda',
    subscribetitleText: 'berlangganan communikasi kami',
    subscribeText: 'berlangganan',
    shareToText: 'berbagi untuk ',
    searchText: 'cari',
    subtractmoneyText: "maximum 600",
    magnanimitycouponText: "untuk kalian ambil",
    drawText: "ambil segera",
    discountText: "diskon berlebihan",
    purchaseText: "Combo buy",
    composecouponText: "Pembelian kombinasi",
    manyDiscountsText: "konsesi lebih",
    recommendtitleText: "Rekomendasi untukmu",
    hotsaleproductyitleText: "produk panas",
    guessLiketitleText: "Sepertinya kau menyukainya",
    NoDataText: "Tidak ada data",
    appraiseText: "evaluasi",
    certificate: "voucher",
    collectText: "Koleksi",
    addCartText: "tambah ke gerobak",
    enterkeywordsText: "Masukkan kata kunci",
    useNowText: "Gunakan segera",
    vouchernoText: "Nomor kupon",
    placeholderyearText:"Tahun pemilihan",
    placeholdermouthText:"Bulan pemilihan",
    placeholderdayText:"hari pemilihan",
    // 优惠券页面
    breadcrumbItemText1: 'ultra',
    breadcrumbItemText2: 'class',
    breadcrumbItemText3: 'besar',
    breadcrumbItemText4: 'fook',
    breadcrumbItemText5: 'leigh',
    magnanimitydrawText: 'grafik besar menunggu untuk kalian pelajari',
    availablecouponstitleText: 'sertifikat produk tersedia',
    drawbtnText: 'mengumpulkan',
    universalText: 'Universal',
    useText: 'gunakan',
    limitText: 'terbatas',
    fullText: 'penuh',
    subtractText: 'dikurangi',
    // 折扣
    discountitemText1: 'Diskon terus ,',
    discountitemText2: 'Sebuah sukses keuntungan besar',
    // 组合
    commoditydiscountitemText1: 'Pembelian kombinasi ,',
    commoditydiscountitemText2: 'Banyak diskon',
    combinedpriceText: 'combo price',
    economizeText: 'tabungan',
    buynowText: "dibeli segera",
    // 产品
    ourproductsText: 'Produk kami',
    productcategoryText: 'Kategori produk',
    recommendtarText: 'merekomendasikan',
    newText: 'Produk baru',
    salesvolumetarText: 'volum penjualan',
    pricetarText: 'Harga',
    // 博客
    blogmanagementText: "Popular Blogs",
    latestblogsText: "The latest blog",
    relatedrlogsText: "Related Blogs",
    priceIncreasecommentText: "Submit comments",
    commentsectionTtxt: "comment area",
    participatingcommentsText: "Participating in comments",
    // 论坛
    postingText: "posting posting",
    topicsText: "topics",
    replyText: "balasan",
    viewText: "melihat",
    lastreplyText: "balasan terakhir",
    publishText: "Sebarkan",
    placeholdertypeText: "pilih teks subjek",
    placeholdertitleText: "mohon masukkan caption",
    placeholdercontentsText: "silakan masukan konten",
    fromtopicText: "dari topik:",
    firstfloor: "Lantai 1",
    floorText: "lantai",
    fromText: "berasal dari:",
    postreplyText: "Post a reply",
    // 个人中心 - 我的订单
    myorderText: "My order",
    mycommentsText: "Komentarku",
    mycollectionText: "Koleksiku",
    couponText: "Coupon",
    shippingaddressText: "Shipping address",
    myPostText: "My post",
    personalinformationText: "Personal information",
    editText: "Edit",
    allordersText: "All orders",
    unpaidText: "To be paid",
    shippedText: "To be shipped",
    receivedText: "To be received",
    evaluatedText: "To be evaluated",
    baidText: "Payment on behalf",
    completedText: "Selesai",
    productinfText: "Informasi produk",
    unitpricethText: "harga tunggal",
    quantitythText: "kuantitas",
    actualpaymentthText: "actualpayment",
    transactionstatusthText: "status perdagangan",
    operationthText: "operasi",
    ordernumberText: "nomor pesanan",
    orderdetailsText: "rincian perintah",
    cancelorderText: "batalkan pesanan",
    confirmText: "Yakin",
    cancelText: "dibatalkan",
    deleteordertitle: "yakin untuk menghapus perintah terkini?",
    successfultradeText: "sukses transaksi",
    paymentText: "pembayaran",
    confirmreceiptText: "konfirmasi penerimaan",
    nncommentText: 'Tak ada komentar.',
    // 个人中心 - 我的评论
    productText: "produk",
    productdetailText: "evaluasi detail",
    replyblogText: "menanggapi blog:",
    //个人中心 - 收货地址
    addseliveryaddressText: "alamat pengiriman baru",
    addaddresstitleText1: "Tersimpan",
    addaddresstitleText2: "sebuah alamat, masih tersimpan,",
    addaddresstitleText3: "alamat",
    defaultText: "standar",
    consigneeText: "penerima:",
    addressText: "dimana alamatnya:",
    fulladdressText: "alamat lengkap:",
    setdefaultText: "set ke default",
    mobilephoneText: "ponsel:",
    viewmoreText: "lihatlagi",
    replypostText: "menanggapi posting:",
    // 个人中心 - 个人信息
    nameLabel:"nama",
    sexlabel:"gender",
    modifyavatarText:"ubah profil",
    sexmanText:"laki-laki",
    sexwomanText:"wanita",
    secrecyText:"rahasia",
    replaceText:"penggantian",
    saveText:"save",
    oldpasswordText:" sandi asli",
    newpasswordText:"sandi baru",
    confirmpasswordText:"konfirmasi sandi",
    opdpleasolderText:"tolong masukkan password asli",
    newpleasolderText:"Tolong, masukkan password baru",
    unboundText:" tidak terikat",
    bindingText:"mengikat",
    unbindingText:"Lepaskan ikatan",
    // 个人中心-个人信息
    regionText:" di wilayah",
    addconsigneleasolderText:"silakan mengisi nama penerima barang",
    countrypleasolderText:"Pilihlah negara ",
    provinceleasolderText:"pilih provinsi",
    citypleasolderText:"pilihlah kota",
    areapleasolderText:"pilih wilayah",
    fulladdressTextpleasolderText:"tolong masukkan alamat asli",
    addconsignephoneleasolderText:"silakan isi penerimanya nomor telepon pria itu.",
    emailpleasolderText:"Tolong masukkan alamat email",
    phoneText:' nomor ponsel ',
    uploadimgText:" upload gambar",
    updateuserface:"modifikasi dalam kepalanya",
    uploadimgtitle1:"Foto dengan format JPG, jpeg, PNG",
    uploadimgtitle2:"Ukuran yang direkomendasikan: 200*200 atau sejenisnya",
    updateemailText:"Modify email",
    updatemobileText:"revisi nomor ponse",
    dialogemailtitle:"alamat email",
    dialogmobiletitle:"nomor telepon pria itu",
    dialogheadertitle:" Input terkait dengan akun bagasimu",
    continueText:"terus",
    verificationinformation:"Verifikasi informasi",
    verificationinformationTitle1:"Untuk melanjutkan, lengkapi langkah verifikasi ini. Kami telah menunjuk",
    verificationinformationTitle2:"Mengirim kode otentikasi. Silakan masukkan di bawah ini.",
    verificationcode:"captcha",
    newtitle:"baru",
    dialognewmobiletitle:"Masukkan nomor ponsel baru untuk diasosiasikan. Dan tekan untuk mengkonfirmasi perubahan",
    confirmpbtnText:"dikonfirmasi",
    titlecpuntryselect:"Pilih negara",
    hotcountrytitle:"hot nation",
    aboutusText:"untuk kita",
    // 订单详情
    havequestionsText:"Diragukan",
    preferentialText:"konsesi",
    enquiryText:"penyelidikan",
    combinationdiscountText:" kombinasi insentif",
    introduceText:"intro",
    buyermycommentsText:"ulasan pembeli",
    starText:"bintang",
    yourmailboxText:" email mu",
    placeholderquestionText:"silahkan menuliskan pertanyaan anda",
    uploadimglimtText:"Tolong unggah file JPG/GIF/PNG. Ukuran gambar tidak lebih dari 2MB.",
    submitbtnText:"submit",
    // 购物车
    selectText:"pilih",
    tipscartsText:"Produk terpilih (kecuali kargo)",
    settlementText:"penyelesaian",
    selectallText:"penuh terpilih",
    amountText:"jumlah",
    addtofavoritesText:"untuk bergabung dalam koleks",
    havecollectedText:"tersedia",
    tipdelecteproduct:"yakin untuk menghapus item saat ini?",
    deleteText:"hapus",
    tipclearcart:"Yakin mengosongkan keranjang belanja?",
    clearcartText:"kereta kosong",
    totalText:"合计",
    totaltipText:"item (kecuali barang-barang):",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_id.js